import { render } from "./HelloWorld.vue?vue&type=template&id=5497d5eb&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=5497d5eb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Devoxx2023UI/Devoxx2023UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5497d5eb"]])

export default __exports__